import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Cuotas } from 'src/app/global/interfaces/cuotas';
import { CuotasResponse } from 'src/app/global/interfaces/cuotas-response';
import { CuotasService } from 'src/app/global/services/cuotas.service';
import { CuotasServiceVM } from 'src/app/view-model/services/cuotas.service';



@Injectable()
export class CuotasProviderVM extends CuotasServiceVM {


    constructor(private cuotasService: CuotasService) {
        super();
    }

    getCuotas(): Observable<CuotasResponse> {

        return this.cuotasService.getCuotas()
            .pipe(map(this.getCuotasOK), catchError(this.serviceError));
    }

    private getCuotasOK(resp) {
        return resp;
    }


    postCuotas(cuotas: Cuotas): Observable<any> {

        return this.cuotasService.postCuotas(cuotas)
            .pipe(map(this.postCuotasOK), catchError(this.serviceError));
    }

    private postCuotasOK(resp) {
        return resp;
    }

    private serviceError(error) {
        return throwError(error);
    }



}
